import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './confirm-dialog.component';

export interface ConfirmationEvent {
  accept(): void;
  reject(): void;
}

/**
 * Confirmation Service wrapper around MatDialog
 * Provides API compatibility with PrimeNG ConfirmationService while using Angular Material
 */
@Injectable({
  providedIn: 'root',
})
export class ConfirmationService {
  constructor(private dialog: MatDialog) {}

  /**
   * Show a confirmation dialog
   * Returns an event object with accept() and reject() callbacks
   */
  confirm(config: {
    message: string;
    header?: string;
    icon?: string;
    accept?: () => void;
    reject?: () => void;
    acceptButtonStyleClass?: string;
    rejectButtonStyleClass?: string;
    acceptLabel?: string;
    rejectLabel?: string;
  }): ConfirmationEvent {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: {
        title: config.header,
        message: config.message,
        icon: config.icon,
        accept: config.acceptLabel || 'OK',
        reject: config.rejectLabel || 'Cancel',
        acceptButtonStyleClass: config.acceptButtonStyleClass,
        rejectButtonStyleClass: config.rejectButtonStyleClass,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        config.accept?.();
      } else {
        config.reject?.();
      }
    });

    return {
      accept: () => {
        dialogRef.close(true);
      },
      reject: () => {
        dialogRef.close(false);
      },
    };
  }
}
